import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchAllPlanNames = async () => {
  const response = await queryExecute({
    query: graphql(`
      query AllPlanNames {
        allPlanNames
      }
    `),
    fetchPolicy: 'no-cache',
  });

  return response.data.allPlanNames;
};
